import styles from './index.module.css'

import * as React from 'react'

import { Button } from 'components/ds'

import AddToDiscoSuccessIcon from '../add-to-disco-success-icon'
import { useTranslation } from '@disco/i18n/use-translation'

export default function AddToDiscoSuccessModal({
  onClose,
}: {
  onClose: () => unknown
}): React.ReactNode {
  const { t } = useTranslation('shares')
  return (
    <div
      className={styles.addToDiscoSuccessModalCont}
      data-testid="add-to-disco-success"
    >
      <div>
        <AddToDiscoSuccessIcon />
      </div>
      <div className={styles.addToDiscoSuccessModalTitle}>
        {t('shares:success', 'Success!')}
      </div>
      <div className={styles.addToDiscoSuccessModalMessage}>
        <div>
          {t(
            'shares:wereAddingThisMusicToYourDisco',
            'We’re adding this music to your DISCO.',
          )}
        </div>
        <div>
          {t(
            'shares:notifiedWhenTransferred',
            'You’ll get a notification in the app when it’s finished transferring.',
          )}
        </div>
      </div>
      <div className={styles.addToDiscoSuccessModalCloseCont}>
        <Button onClick={onClose}>{t('shares:close', 'Close')}</Button>
      </div>
    </div>
  )
}
